import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice, Pager } from "../../lib/ui";

/* Stock replenishment history – port of addStockreplenish.php + stockReprenish_ajax.php (API: GET /api/replenishments) */

const COLS = [["replenishment_id", "ID", true], ["product_id", "Product", false], ["quantity_added", "Quantity added", true],
  ["purchase_price", "Purchase price", true], ["supplier", "Supplier", false], ["replenishment_date", "Date", false]];

export default function Replenishments() {
  const api = useApi();
  const [q, setQ] = useState({ page: 1, sort: "replenishment_id", order: "DESC", search: "" });
  const [term, setTerm] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async (p) => { try { setData(await api.get("/api/replenishments", p)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.search === term ? s : { ...s, search: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  const sortBy = (k) => setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "ASC" ? "DESC" : "ASC", page: 1 }));

  return (
    <main className="pg">
      <PageHeader slug="addStockreplenish" actions={<Link to="/stockReprenish" className="btn primary"><i className="fas fa-truck-ramp-box" /> Replenish stock</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <div className="toolbar"><div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" />
          <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search supplier or product ID" aria-label="Search replenishments" /></div></div></div>
        <div className="tbl-wrap">
          <table className="tbl">
            <thead><tr>{COLS.map(([k, label, num]) => (
              <th key={k} className={`sortable ${num ? "num" : ""}`} onClick={() => sortBy(k)} aria-sort={q.sort === k ? (q.order === "ASC" ? "ascending" : "descending") : "none"}>
                {label} {q.sort === k && <i className={`fas ${q.order === "ASC" ? "fa-sort-up" : "fa-sort-down"}`} />}</th>))}</tr></thead>
            <tbody>
              {data?.rows.map((r) => (
                <tr key={r.replenishment_id}>
                  <td className="num mono">{r.replenishment_id}</td>
                  <td><span style={{ fontWeight: 600, color: "var(--ink)" }}>{r.product_name || "Unknown product"}</span> <span className="mono" style={{ color: "var(--muted)", fontSize: ".75rem" }}>#{r.product_id}</span></td>
                  <td className="num mono">{r.quantity_added}</td><td className="num mono">{n2(r.purchase_price)}</td>
                  <td>{r.supplier || "–"}</td><td>{r.replenishment_date || "–"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data && data.rows.length === 0 && <div className="empty"><i className="fas fa-truck" />No replenishments recorded.</div>}
        </div>
        {data && <Pager page={data.page} totalPages={data.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
    </main>
  );
}
